var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { connect } from 'react-redux';
import * as classNames from 'classnames';
import { Mutation, Query } from 'react-apollo';
import { matchRoutes } from 'react-router-config';
import { withStyles } from '@material-ui/core/styles';
import { Icon, Dialog, IconButton, DialogTitle, DialogContent } from '@material-ui/core';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import * as MobileDetect from 'mobile-detect/mobile-detect';
import history from '../../../history';
import HelpTrackList from './HelpTrackList';
import { compose } from 'src/utils/common';
import { getHelpVideosData } from 'src/gql/queries/getHelpVideo';
import { userCommandMutation, userCommandVariables } from '../../../gql/userCommand';
var styles = function (theme) { return ({
    closeButton: {
        position: 'absolute',
        right: -12,
        top: -12,
        color: theme.palette.grey[500],
        '& > span > span': {
            fontSize: 40,
        },
        '@media(max-width: 1024px)': {
            right: -28,
            top: -28,
            '& > span > span': {
                fontSize: 30,
            },
        },
    },
    helpDialogContent: {
        '@media(max-width: 1024px)': {
            flexDirection: 'column',
            '& > div': {
                width: '100%',
                marginBottom: 20,
            },
        },
    },
    helpDialogTitle: {
        '& > h2': {
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            '@media(max-width: 1024px)': {
                flexDirection: 'column',
                alignItems: 'start',
            },
        },
    },
}); };
var HelpDialog = /** @class */ (function (_super) {
    __extends(HelpDialog, _super);
    function HelpDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.getTag = function () {
            var pageTags = _this.props.pageTags;
            var branch = matchRoutes(_this.props.routes, history.location.pathname)[0];
            return pageTags && pageTags[branch.match.path] && pageTags[branch.match.path].length
                ? pageTags[branch.match.path][0]
                : {
                    tagGroup: '',
                    tagValue: '',
                };
        };
        _this.closeMenu = function () {
            _this.props.onClose(false);
        };
        _this.state = {
            selectedLang: 'en-us',
        };
        return _this;
    }
    HelpDialog.prototype.render = function () {
        var _this = this;
        var _a = this.props, open = _a.open, classes = _a.classes, translate = _a.translate, videosWatched = _a.videosWatched;
        var currentTag = this.getTag();
        if (!currentTag.tagGroup && !currentTag.tagValue) {
            return (React.createElement(Dialog, { fullWidth: true, maxWidth: "md", open: open, PaperProps: {
                    style: {
                        height: 540,
                    },
                }, onClose: function () {
                    _this.closeMenu();
                } },
                React.createElement(DialogTitle, { className: classes.helpDialogTitle },
                    translate('help-dialog-title'),
                    React.createElement(IconButton, { id: "help-dialog-close-btn", className: classes.closeButton, onClick: function () {
                            _this.closeMenu();
                        } },
                        React.createElement(Icon, null, "close"))),
                React.createElement(DialogContent, null,
                    React.createElement("p", { className: "p-24" }, translate('no-tag-defined')))));
        }
        var branch = matchRoutes(this.props.routes, history.location.pathname)[0];
        var dialogData = (React.createElement(Query, __assign({}, getHelpVideosData(branch.match.path, null, undefined)), function (_a) {
            var loading = _a.loading, error = _a.error, data = _a.data;
            if (loading) {
                return React.createElement("div", { className: classNames(classes.helpDialogContent, 'w-full flex') }, "loading");
            }
            var helpVideos = (data && data.helpVideos) || {
                featuredVideo: null,
                videos: [],
            };
            var featuredVideoData = data &&
                data.helpVideos &&
                data.helpVideos.videos &&
                data.helpVideos.videos[0] &&
                data.helpVideos.videos[0].items
                ? data.helpVideos.videos[0].items.find(function (item) { return item.id === 'dQlyH4Z2'; })
                : undefined;
            return (React.createElement("div", null,
                React.createElement(DialogTitle, { className: classes.helpDialogTitle },
                    React.createElement("span", null, featuredVideoData ? featuredVideoData.name : translate('help-dialog-title')),
                    React.createElement(IconButton, { id: "close-tooltip-btn", className: classes.closeButton, onClick: function () {
                            _this.closeMenu();
                        } },
                        React.createElement(Icon, null, "close"))),
                React.createElement(DialogContent, null, helpVideos.videos && helpVideos.videos.length ? (React.createElement("div", { className: classNames(classes.helpDialogContent, 'w-full flex') },
                    React.createElement("div", { className: 'w-full' },
                        React.createElement(HelpTrackList, { tracks: helpVideos.videos, videosWatched: videosWatched, lang: _this.state.selectedLang, featuredVideoId: featuredVideoData ? featuredVideoData.humanId : '', onClose: function () {
                                _this.closeMenu();
                            } })))) : (React.createElement("p", { className: "p-24" }, translate('no-tag-defined'))))));
        }));
        var md = new MobileDetect(window.navigator.userAgent);
        var isMobile = md.mobile();
        return (React.createElement(Dialog, { fullWidth: true, maxWidth: "md", PaperProps: {
                style: {
                    height: 540,
                },
            }, open: open || (this.props.isLoadingComplete && !isMobile), onClose: function () {
                _this.closeMenu();
            } }, dialogData));
    };
    return HelpDialog;
}(React.PureComponent));
function mapStateToProps(_a) {
    var auth = _a.auth, translation = _a.translation;
    return {
        pageTags: auth.organization.pageTags || {},
        lang: translation.lang,
        tubeColor: auth.tube.color,
    };
}
export default withStyles(styles)(connect(mapStateToProps, null)(function (props) {
    return (React.createElement(Mutation, __assign({}, userCommandMutation()), function (userCommandReq) {
        var Comp = compose(connect(mapStateToProps))(HelpDialog);
        return (React.createElement(Comp, __assign({}, props, { saveTooltipPopupPreference: function (tooltip) {
                return userCommandReq(userCommandVariables({
                    type: 'updateTooltipPopupPreference',
                    payload: { disabled: tooltip },
                }));
            } })));
    }));
}));



//////////////////
// WEBPACK FOOTER
// ./src/components/layouts/Main/HelpDialog.tsx
// module id = 2032
// module chunks = 81